import { render, staticRenderFns } from "./BarTrheeColors.vue?vue&type=template&id=9cee8618&scoped=true&lang=pug"
import script from "./BarTrheeColors.vue?vue&type=script&lang=js"
export * from "./BarTrheeColors.vue?vue&type=script&lang=js"
import style0 from "./BarTrheeColors.vue?vue&type=style&index=0&id=9cee8618&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cee8618",
  null
  
)

export default component.exports